/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/moveToShelf.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { MOVE_TO_SHELF } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IMoveToShelfMethods extends IPluginMethodMap {
  moveToShelf(args: any): Promise<any>;
}

export class moveToShelfService implements IAgentPlugin {
  readonly methods: IMoveToShelfMethods;

  constructor() {
    this.methods = {
      moveToShelf: this.moveToShelf.bind(this),
    };
  }

  async moveToShelf(args: any) {
    log.blue(`moveToShelf server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.mutate({
          mutation: MOVE_TO_SHELF,
          variables: {
            ...args?.payload,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.moveBoxesToShelf) {
          return {
            ...res?.data?.moveBoxesToShelf,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
